document.addEventListener('DOMContentLoaded', function () {
  const loadingScreen = document.getElementById('loading-screen');
  const mainSite = document.getElementById('main-site');

  function revealSite() {
    if (!mainSite) return;
    mainSite.hidden = false;
    if (loadingScreen) {
      loadingScreen.style.opacity = '0';
      loadingScreen.style.visibility = 'hidden';
      window.setTimeout(() => loadingScreen.remove(), 500);
    }
  }

  if (loadingScreen && mainSite) {
    const hasSeenLoading = sessionStorage.getItem('driplingLoaderSeen');
    if (hasSeenLoading) {
      revealSite();
    } else {
      const protocolText = document.getElementById('protocol-text');
      const loadingBar = document.getElementById('loading-bar');
      const statusMessage = document.getElementById('status-message');
      const lines = [
        '> booting DRIPLING_ATELIER.OS',
        '> mounting archive / 2024-2025',
        '> verifying object registry',
        '> loading character index',
        '> atelier.exe status: IN PRODUCTION',
        '> visitor clearance: VIEW ONLY',
        '> signal intercepted',
        '> system online_'
      ];

      if (protocolText) {
        lines.forEach((line, i) => {
          const row = document.createElement('div');
          row.className = 'protocol-line' + (i === 5 ? ' glitch' : '');
          row.textContent = line;
          protocolText.appendChild(row);
        });
      }

      let progress = 0;
      let tick = 0;
      const timer = window.setInterval(() => {
        progress = Math.min(100, progress + 7 + Math.random() * 10);
        tick += 1;
        if (loadingBar) loadingBar.style.width = progress + '%';
        if (statusMessage) statusMessage.textContent = lines[tick % lines.length].replace(/^>\s*/, '');
        if (progress >= 100) {
          window.clearInterval(timer);
          try { sessionStorage.setItem('driplingLoaderSeen', '1'); } catch (e) {}
          window.setTimeout(revealSite, 260);
        }
      }, 120);
    }
  } else if (mainSite) {
    mainSite.hidden = false;
  }

  const menuToggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-terminal-nav]') || document.getElementById('TerminalNav');
  const siteHeader = document.querySelector('[data-site-header]');

  function closeMobileMenu() {
    if (!menuToggle || !nav) return;
    nav.classList.remove('is-open');
    menuToggle.setAttribute('aria-expanded', 'false');
    menuToggle.textContent = 'MENU_';
    document.documentElement.classList.remove('terminal-menu-open');
  }

  if (menuToggle && nav) {
    menuToggle.addEventListener('click', function () {
      const isOpen = nav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', String(isOpen));
      menuToggle.textContent = isOpen ? 'CLOSE_' : 'MENU_';
      document.documentElement.classList.toggle('terminal-menu-open', isOpen);
    });

    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMobileMenu);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && nav.classList.contains('is-open')) {
        closeMobileMenu();
        menuToggle.focus();
      }
    });

    document.addEventListener('pointerdown', function (event) {
      if (!nav.classList.contains('is-open') || !siteHeader) return;
      if (!siteHeader.contains(event.target)) closeMobileMenu();
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 1180) closeMobileMenu();
    }, { passive: true });
  }

  const archiveSearch = document.querySelector('[data-archive-search]');
  if (archiveSearch) {
    const cards = Array.from(document.querySelectorAll('[data-art-card]'));
    const empty = document.querySelector('[data-archive-empty]');
    archiveSearch.addEventListener('input', function () {
      const q = archiveSearch.value.trim().toLowerCase();
      let visible = 0;
      cards.forEach(card => {
        const haystack = (card.getAttribute('data-art-search') || '').toLowerCase();
        const match = !q || haystack.includes(q);
        card.hidden = !match;
        if (match) visible += 1;
      });
      if (empty) empty.hidden = visible !== 0;
    });
  }
});
